export default "__VITE_ASSET__DS1A4z$F__"